export default __webpack_public_path__ + "96363087848f536a241b18c69a7b1e3e.png";